enum VehicleLoanInsuranceStatus {
  NONE = 'NONE',
  ONE_CONTRACT_OWNER = 'ONE_CONTRACT_OWNER',
  BOTH_CONTRACT_OWNERS = 'BOTH_CONTRACT_OWNERS',
}

export default VehicleLoanInsuranceStatus;
